import React from "react";
import "./Styles.css";
import { FaBrain, FaMagic, FaLock, FaRocket } from "react-icons/fa";

export default function FeaturesSection() {
  const features = [
    {
      icon: <FaBrain />,
      title: "Intelligent Experiences",
      desc: "AI that understands context, learns continuously, and delivers real value.",
    },
    {
      icon: <FaMagic />,
      title: "Easy to Use",
      desc: "Beautiful, simple, and intuitive products designed for everyday people.",
    },
    {
      icon: <FaLock />,
      title: "Private & Secure",
      desc: "Built with privacy-first principles and enterprise-grade security.",
    },
    {
      icon: <FaRocket />,
      title: "Always Evolving",
      desc: "We ship fast, iterate continuously, and stay ahead of tomorrow.",
    },
  ];

  return (
    <div className="features-container">
      <div className="features-inner">

        <p className="features-tag">WHAT WE BUILD</p>

        <h2 className="features-title">
          AI that works for everyone
        </h2>

        <div className="features-grid">
          {features.map((item, index) => (
            <div key={index} className="feature-card">
              
              <div className="icon-wrapper">
                {item.icon}
              </div>

              <h4>{item.title}</h4>
              <p>{item.desc}</p>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
}